// // frontend/src/context/SearchContext.js

// import React, { createContext, useState, useContext } from "react";

// const SearchContext = createContext();

// export const SearchProvider = ({ children }) => {
//   const [searchData, setSearchData] = useState({
//     query: "",
//     aiQuery: "",
//     results: [],
//     noResults: false,
//     aiResults: [],
//     country: "", // Add country
//     state: "",   // Add state
//   });

//   return (
//     <SearchContext.Provider value={{ searchData, setSearchData }}>
//       {children}
//     </SearchContext.Provider>
//   );
// };

// export const useSearchContext = () => useContext(SearchContext);

import React, { createContext, useContext, useState } from "react";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchData, setSearchData] = useState({
    query: "",
    results: [],
    aiQuery: "",
    aiResults: [],
    noResults: false,
  });

  return (
    <SearchContext.Provider value={{ searchData, setSearchData }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearchContext = () => useContext(SearchContext);
